import Tone from 'tone';

export const getValueExactlyAtStep = (step, automations) => {
    let aut  = automations.find(
        x => Math.floor(x.step) === step);
    if (aut) {
        return aut.value;
    }
    return undefined;
}

export const getAllValuesAtStep = (step, automation) => {
    return automation.stepToValues[step] || [];
};

export const getValueAtStep = (step, parameter, automations) => {
    let isStepFunction = parameter.config.stepAutomation;
    let firstValue = automations[0];
    let value = parameter.get(true);
    if (parameter.getNumberFromOption) {
        value = parameter.getNumberFromOption(value);
    }
    if (typeof value === "string") {
        value = new Tone.Time(value).toFrequency();
    }
    
    if (automations.length === 0) {
        return value;
    }
    
    let lastEvent;
    for (let i in automations) {
        i = parseInt(i);
        let event = automations[i];
        lastEvent = event;
        if (event.step <= step) {
            if (event.value === null) {
                return null;
            }
            if (automations[i+1] && step < automations[i+1].step) {
                let _value = event.value === undefined ? parameter.get(true) : event.value;
                if (typeof _value === "function") {
                    _value = _value();
                }
                if (isStepFunction) {
                    return _value;
                }
                let nextEvent = automations[i+1];
                let distance = nextEvent.step - event.step;
                let innerDistance = step - event.step;
                let nextValue = typeof nextEvent.value === "function" ? nextEvent.value() : nextEvent.value;
                let slope = (nextValue- _value) / (nextEvent.step - event.step);
                let value = _value + innerDistance * slope;
                value = parameter.toFrequency ? new Tone.Time(value) : value;
                return value;
            } 
        }
    }
    
    if (lastEvent && step >= lastEvent.step) {
        if (lastEvent.value === null) {
            return null;
        }
        let _value = lastEvent.value === undefined ?
            parameter.get(true) : lastEvent.value;
        if (typeof _value === "function") {
            return _value();
        }
        return _value;
    }
    
    if (firstValue) {
        // if it's before the first value
        let v = firstValue.value;
        return typeof v === "function" ? v() : v;
    } 
    return value;
};
